import React, { useState } from "react";
import FileUpload from "../../../util/FileUpload";

const CreateSite = ({ onSubmit, siteTypes, onCancel }) => {
  const nameRef = React.createRef();
  const addressRef = React.createRef();
  const emailRef = React.createRef();
  const telNoRef = React.createRef();
  const websiteRef = React.createRef();
  const sitetypeRef = React.createRef();
  const [logo, setLogo] = useState(null);
  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        const name = nameRef.current.value;
        const address = addressRef.current.value;
        const email = emailRef.current.value;
        const tel = telNoRef.current.value;
        const website = websiteRef.current.value;
        const type = sitetypeRef.current.value;
        onSubmit({ name, address, email, tel, website, type, logo });
      }}
    >
      <div className="form-body">
        <div className="form-group row">
          <label className="control-label col-md-4">
            Name
            <span className="required"> * </span>
          </label>
          <div className="col-md-8">
            <input
              type="text"
              name="name"
              ref={nameRef}
              data-required="1"
              required
              placeholder="Site name"
              className="form-control input-height"
            />
          </div>
        </div>

        <div className="form-group row">
          <label className="control-label col-md-4">
            Email
            <span className="required"> * </span>
          </label>
          <div className="col-md-8">
            <input
              type="email"
              ref={emailRef}
              className="form-control input-height"
              name="email"
              required
              placeholder="Email Address"
            />
          </div>
        </div>

        <div className="form-group row">
          <label className="control-label col-md-4">
            Mobile No.
            <span className="required"> * </span>
          </label>
          <div className="col-md-8">
            <input
              name="tel_number"
              type="text"
              ref={telNoRef}
              required
              placeholder="Mobile number"
              className="form-control input-height"
            />
          </div>
        </div>

        <div className="form-group row">
          <label className="control-label col-md-4">
            Website
            <span className="required"> * </span>
          </label>
          <div className="col-md-8">
            <input
              name="website"
              type="text"
              required
              ref={websiteRef}
              placeholder="Website Address"
              className="form-control input-height"
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="control-label col-md-4">
            Site Type
            <span className="required" aria-required="true">
              *
            </span>
          </label>
          <div className="col-md-8">
            <select
              className="form-control input-height"
              name="type"
              ref={sitetypeRef}
            >
              <option value="">Select...</option>
              {siteTypes &&
                siteTypes.map(x => {
                  return (
                    <option key={x.id} value={x.id}>
                      {x.name}
                    </option>
                  );
                })}
            </select>
          </div>
        </div>
        <div className="form-group row">
          <label className="control-label col-md-4">
            Address
            <span className="required"> * </span>
          </label>
          <div className="col-md-8">
            <input
              name="address"
              type="textarea"
              row="4"
              required
              ref={addressRef}
              placeholder="Physical Address"
              className="form-control input-height"
            />
          </div>
        </div>
        <div className="form-group row">
          <div className="col-md-8 offset-md-4">
            <FileUpload
              title="Select Logo"
              onData={({ path }) => setLogo(path)}
            />
          </div>
        </div>
        <div className="text-center">
          <button
            type="button"
            className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle margin-right-10 btn-default"
            onClick={onCancel}
          >
            <i className="material-icons text-danger">cancel</i> Cancel
          </button>
          <button
            type="submit"
            className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-success"
          >
            Submit <i className="material-icons">arrow_forward</i>
          </button>
        </div>
      </div>
    </form>
  );
};

export default CreateSite;
